module.exports = __webpack_public_path__ + "static/media/oau_prev.7fa3eb08.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/img/current/oau_prev.png
// module id = 99
// module chunks = 0